import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BusinessSetupProvider } from '../context/BusinessSetupContext';

const BusinessSetupLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const step = params.get('step');
    if (!step) return;
    // Normalize step and navigate to sub-route once
    const map = new Map([
      ['market-analysis', 'market-analysis'],
      ['business-model', 'business-model'],
      ['revenue-forecast', 'revenue-forecast'],
      ['funding-plan', 'funding-plan'],
      ['exit-strategy', 'exit-strategy'],
      ['full-plan', 'full-plan'],
      ['review-plan', 'review-plan'],
    ]);
    const to = map.get(step);
    if (to && !location.pathname.endsWith(to)) {
      navigate(`/User/business-setup/${to}`, { replace: true });
    }
  }, [location, navigate]);

  return (
    <BusinessSetupProvider>
      <Outlet />
    </BusinessSetupProvider>
  );
};

export default BusinessSetupLayout;
